import { render } from "./VariantsTable.vue?vue&type=template&id=0127a979"
import script from "./VariantsTable.vue?vue&type=script&lang=js"
export * from "./VariantsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__